import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'components/Card';
import Heading from 'components/Heading';
import Divider from 'components/Divider';
import PlaylistContentTree from 'components/PlaylistContentTree';
import { BASIC } from 'styles/spacingPresets';
import { getContentAsTree, getRankedContentTree } from '../Editor/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlaylistManageContentPreview(_ref) {
  var initialPlaylistData = _ref.initialPlaylistData,
    reducerState = _ref.reducerState;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _reducerState = _slicedToArray(reducerState, 1),
    content = _reducerState[0].content;
  var contentAsTree = getContentAsTree(content);
  var rankedContentAsTree = getRankedContentTree({
    contentTree: contentAsTree
  });
  return /*#__PURE__*/_jsxs(Card, {
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS,
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h2",
      children: t('actions_preview_content')
    }), /*#__PURE__*/_jsx(Divider, {
      my: BASIC.MEDIUM,
      breakpoints: BASIC.BREAKPOINTS
    }), /*#__PURE__*/_jsx(PlaylistContentTree, {
      playlistContent: rankedContentAsTree,
      parentPlaylist: initialPlaylistData,
      isEditablePlaylist: false,
      isPreviewMode: true
    })]
  });
}